import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Typography } from "@mui/material";
import HolidayViewController from "../../redux/actions/HolidayApiAction";
import { useSelector, useDispatch } from "react-redux";
import "react-calendar/dist/Calendar.css"; // calendar styling
import { format } from "date-fns";

const Holiday = () => {
  const { getEmployerHoliday } = HolidayViewController();
  const dispatch = useDispatch();
  const { employer_holiday } = useSelector((state) => state.employer_holidays);

  const [currentDate, setCurrentDate] = useState(new Date());
  const [selectedHoliday, setSelectedHoliday] = useState(null);
  const [selectedDate, setSelectedDate] = useState(
    format(new Date(), "yyyy-MM-dd")
  ); // Default to current date

  useEffect(() => {
    dispatch(getEmployerHoliday());
  }, [dispatch]);

  useEffect(() => {
    dispatch(getEmployerHoliday());
  }, [dispatch]);

  useEffect(() => {
    if (employer_holiday && employer_holiday.length > 0) {
      const todayDate = format(new Date(), "yyyy-MM-dd");
      const todayHoliday = employer_holiday.find(
        (h) => h.holiday?.date === todayDate
      );

      if (todayHoliday) {
        setSelectedHoliday(todayHoliday);
        setSelectedDate(todayDate);
      }
    }
  }, [employer_holiday]);

  const handlePrevMonth = () => {
    setCurrentDate(
      new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1)
    );
  };

  const handleNextMonth = () => {
    setCurrentDate(
      new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1)
    );
  };

  const getMonthName = (date) => {
    return date.toLocaleString("default", { month: "long", year: "numeric" });
  };

  const handleHolidayClick = (holiday) => {
    setSelectedHoliday(holiday); // Set selected holiday details
    setSelectedDate(holiday.holiday?.date); // Update the selected date to the holiday date
  };

  const handleDateClick = (date) => {
    setSelectedHoliday(null); // Reset the selected holiday details
    setSelectedDate(format(date, "yyyy-MM-dd")); // Update the selected date to the clicked date
  };

  const capitalizeFirst = (str) =>
    str ? str.charAt(0).toUpperCase() + str.slice(1) : "";

  const getFirstDayOfMonth = (month, year) => {
    return new Date(year, month, 1).getDay();
  };

  const daysInMonth = (month, year) => {
    return new Date(year, month + 1, 0).getDate();
  };

  return (
    <Container fluid style={{ paddingLeft: 0, paddingRight: 0 }}>
      <div style={{ maxHeight: "100vh", paddingLeft: 0, paddingRight: 0 }}>
        {/* <div className="card d-flex d-flex-direction-row align-items-center">
          <div className="ms-3">
            <h3>Holidays</h3>
          </div>
        </div> */}
        <Row>
          <Col>
            <div className="calendar-container card mt-4 p-3">
              <div className="d-flex justify-content-between align-items-center mb-2">
                <Button variant="outlined" onClick={handlePrevMonth}>
                  &lt; Prev
                </Button>
                <h5 className="mb-0">{getMonthName(currentDate)}</h5>
                <Button variant="outlined" onClick={handleNextMonth}>
                  Next &gt;
                </Button>
              </div>

              <div className="calendar-grid">
                {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map(
                  (day) => (
                    <div className="calendar-header" key={day}>
                      {day}
                    </div>
                  )
                )}

                {Array(
                  getFirstDayOfMonth(
                    currentDate.getMonth(),
                    currentDate.getFullYear()
                  )
                )
                  .fill(null)
                  .map((_, i) => (
                    <div key={`empty-${i}`} className="calendar-cell empty" />
                  ))}

                {Array(
                  daysInMonth(currentDate.getMonth(), currentDate.getFullYear())
                )
                  .fill(null)
                  .map((_, i) => {
                    const date = i + 1;
                    const fullDate = new Date(
                      currentDate.getFullYear(),
                      currentDate.getMonth(),
                      date
                    )
                      .toISOString()
                      .split("T")[0]; // YYYY-MM-DD

                    const holiday = employer_holiday.find(
                      (h) => h.holiday?.date === fullDate
                    );

                    return (
                      <div
                        key={date}
                        className={`calendar-cell ${
                          holiday ? "holiday-cell" : "normal-cell"
                        }`}
                        onClick={() =>
                          holiday
                            ? handleHolidayClick(holiday)
                            : handleDateClick(
                                new Date(
                                  currentDate.getFullYear(),
                                  currentDate.getMonth(),
                                  date
                                )
                              )
                        }
                      >
                        <div className="date-number">{date}</div>
                        {holiday && (
                          <span
                            className="symbol"
                            style={{ fontSize: "0.7rem", fontWeight: "bold" }}
                          >
                            H
                          </span>
                        )}
                      </div>
                    );
                  })}
              </div>
            </div>
          </Col>

          {/* Display selected holiday or date details below the calendar */}
          <Col>
            <Col>
              <Row>
                <div
                  className="calendar-container card mt-4 p-3"
                  style={{
                    background: "#d7e1ec",
                    color: "#000"
                  }}
                >
                  <Typography variant="h6">
                    Holidays in {getMonthName(currentDate)}
                  </Typography>
                </div>
              </Row>

              {/* Filter holidays of the current month */}
              {(() => {
                const currentMonthHolidays = employer_holiday.filter((h) => {
                  const holidayDate = new Date(h.holiday?.date);
                  return (
                    holidayDate.getFullYear() === currentDate.getFullYear() &&
                    holidayDate.getMonth() === currentDate.getMonth()
                  );
                });

                if (currentMonthHolidays.length === 0) {
                  return (
                    <Row className="mt-2">
                      <div
                        className="calendar-container card p-3"
                        style={{
                          background: "#f8d7da",
                          color: "#721c24"
                        }}
                      >
                        <Typography variant="body1" fontWeight="bold">
                          This month has no holiday.
                        </Typography>
                      </div>
                    </Row>
                  );
                }

                return currentMonthHolidays.map((holiday, index) => (
                  <Row key={index} className="mb-0">
                    <div
                      className="calendar-container card p-3"
                      style={{
                        background: "#b8daff",
                        cursor: "pointer"
                      }}
                      onClick={() => handleHolidayClick(holiday)}
                    >
                      <Typography
                        variant="subtitle1"
                        fontWeight="bold"
                        color="#000"
                      >
                        {capitalizeFirst(holiday.holiday?.occasion) ||
                          "Unnamed Holiday"}
                      </Typography>
                      <Typography variant="body2" style={{ color: "#000" }}>
                        {holiday.holiday?.date
                          ? format(
                              new Date(holiday.holiday?.date),
                              "eeee, d MMMM yyyy"
                            )
                          : "N/A"}
                      </Typography>
                    </div>
                  </Row>
                ));
              })()}
            </Col>
          </Col>
        </Row>
      </div>
    </Container>
  );
};

export default Holiday;

{
  /* <Row>
            <div className="calendar-container card mt-4 p-3"
              style={{
                background: selectedHoliday ? "linear-gradient(135deg, #ff1a21, #fad0c4)" : "#d7e1ec",
                color: "#000",
                display: "flex",
                flexDirection: "column",
              }}
            >
              {selectedHoliday ? (
                <>
                  <Typography variant="h6">
                    Holiday Occasion: {selectedHoliday.holiday?.occasion || "N/A"}
                  </Typography>
                  <Typography variant="body2">
                    <strong>Date:</strong> {selectedHoliday.holiday?.date 
                      ? format(new Date(selectedHoliday.holiday?.date), 'eeee, d MMMM yyyy') 
                      : "N/A"}
                  </Typography>
                </>
              ) : (
                <Typography variant="body1">
                   Date: {format(new Date(selectedDate), 'eeee, d MMMM yyyy')}
                </Typography>
              )}
            </div>
            </Row> */
}
